import React from 'react'
import "./color.css"

function GreenLL() {
    var x = localStorage.getItem("percentage llp")
    return (
        <div className = "green__backgroundll">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default GreenLL
